var _g, _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImg261(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_522_5795)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 34.5,
    r: 12.5,
    fill: "#FEE06E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 20.0002C32.9891 20.0002 34.8968 20.7904 36.3033 22.1969C37.7098 23.6035 38.5 25.5111 38.5 27.5002V36.2502H33.5V27.5002C33.5 26.8372 33.2366 26.2013 32.7678 25.7325C32.2989 25.2636 31.663 25.0002 31 25.0002C30.337 25.0002 29.7011 25.2636 29.2322 25.7325C28.7634 26.2013 28.5 26.8372 28.5 27.5002V36.2502H23.5V27.5002C23.5 25.5111 24.2902 23.6035 25.6967 22.1969C27.1032 20.7904 29.0109 20.0002 31 20.0002Z",
    stroke: "#191919",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21.2502H13.5V36.2502H18.5V21.2502Z",
    stroke: "#191919",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17.5002C17.3807 17.5002 18.5 16.381 18.5 15.0002C18.5 13.6195 17.3807 12.5002 16 12.5002C14.6193 12.5002 13.5 13.6195 13.5 15.0002C13.5 16.381 14.6193 17.5002 16 17.5002Z",
    stroke: "#191919",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5552,
    cy: 35.0558,
    r: 1.5,
    transform: "rotate(166.125 44.5552 35.0558)",
    fill: "#263238"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.0161,
    cy: 42.068,
    r: 1.5,
    transform: "rotate(166.125 37.0161 42.068)",
    fill: "#263238"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8766 42.8527C43.5915 42.6761 44.3142 43.1125 44.4908 43.8274C44.5332 43.9991 44.642 44.1469 44.7934 44.2382C44.9447 44.3296 45.1262 44.3572 45.2979 44.3148C45.4695 44.2724 45.6173 44.1635 45.7087 44.0122C45.8001 43.8608 45.8276 43.6793 45.7852 43.5077C45.5969 42.7997 46.0259 42.0748 46.7371 41.8991L46.7599 41.8935C46.9316 41.8511 47.0793 41.7423 47.1707 41.5909C47.2621 41.4396 47.2896 41.2581 47.2472 41.0864C47.2048 40.9148 47.096 40.767 46.9446 40.6756C46.7933 40.5842 46.6118 40.5567 46.4402 40.5991C45.7232 40.7895 44.9913 40.3475 44.826 39.6244C44.7836 39.4527 44.6747 39.305 44.5234 39.2136C44.372 39.1222 44.1906 39.0947 44.0189 39.1371C43.8473 39.1795 43.6995 39.2883 43.6081 39.4397C43.5167 39.591 43.4892 39.7725 43.5316 39.9441L43.5372 39.9669C43.7129 40.6782 43.2711 41.3953 42.5569 41.5583C42.3852 41.6007 42.2374 41.7096 42.1461 41.8609C42.0547 42.0123 42.0271 42.1937 42.0695 42.3654C42.1119 42.537 42.2208 42.6848 42.3721 42.7762C42.5235 42.8676 42.705 42.8951 42.8766 42.8527Z",
    fill: "#263238"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_522_5795",
    x: 0.291667,
    y: 6.14583,
    width: 44.4167,
    height: 44.4167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.854167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.854167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_522_5795"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_522_5795",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImg261);
export default __webpack_public_path__ + "static/media/icon-img-26-1.59141b0b3ffedf5222c023c836106aae.svg";
export { ForwardRef as ReactComponent };